export default {
  appendKeyframes: function (name, frames) {
    var idx = document.styleSheets[0].cssRules.length
    document.styleSheets[0].insertRule('@keyframes ' + name + ' { ' + frames + ' }', idx)
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/epic-spinners/src/services/utils.js
// module id = 99
// module chunks = 0